// Packages:
import styled from 'styled-components'


// Exports:
export const Wrapper = styled.div`
  position: start;
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 0rem;
  max-height: 730px;
  border-radius: 4px;
  margin: 0 ;
  color: rgba(255, 255, 255, 0);
`

export const FiltersTitle = styled.div`
  height: 50px;
  font-size: 14px;
  padding-top: 14px;
  font-weight: bold;
  margin-bottom: 20px;
`